import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import UserHomeHeader from './UserHomeHeader';
import UserHomeSidebar from './UserHomeSidebar';
import UserHomeFooter from './UserHomeFooter';
import { apiService } from '../../services/api';
import './UserHome.css';

function UserHomeLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Get user data from localStorage
  const getUserData = () => {
    try {
      // Try 'user' first (from login), then fall back to 'userData'
      const userData = localStorage.getItem('user') || localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  };

  const [user, setUser] = useState(getUserData());

  // Check if mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        // Load sidebar state from localStorage on desktop
        const savedState = localStorage.getItem('sidebarCollapsed');
        setIsSidebarOpen(savedState !== 'true');
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Save sidebar state to localStorage (desktop only)
  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem('sidebarCollapsed', (!isSidebarOpen).toString());
    }
  }, [isSidebarOpen, isMobile]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = async () => {
    try {
      // Call logout API to destroy session
      await apiService.logout();
      
      console.log('[Logout] User logged out successfully');
    } catch (error) {
      console.error('[Logout] Error during logout:', error);
      // Continue with local cleanup even if API call fails
    } finally {
      // Redirect to landing page
      navigate('/');
    }
  };

  const closeSidebarIfMobile = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="user-home-layout">
      <UserHomeHeader 
        user={user}
        onToggleSidebar={toggleSidebar}
        onLogout={handleLogout}
        isMobile={isMobile}
      />
      
      <div className="user-home-layout__container">
        <UserHomeSidebar 
          isOpen={isSidebarOpen}
          isMobile={isMobile}
          onClose={closeSidebarIfMobile}
          onToggle={toggleSidebar}
        />
        
        {/* Overlay for mobile */}
        {isMobile && isSidebarOpen && (
          <div 
            className="user-home-layout__overlay"
            onClick={closeSidebarIfMobile}
          />
        )}
        
        <main className={`user-home-layout__main ${isSidebarOpen && !isMobile ? 'sidebar-open' : ''}`}>
          <div className="user-home-layout__content">
            <Outlet />
          </div>
          <UserHomeFooter />
        </main>
      </div>
    </div>
  );
}

export default UserHomeLayout;



